import { handleActions } from 'redux-actions';

import { NAMES as SERVER_VOD_SETTINGS_GET } from 'shared/redux/server/actions/vod-settings/get';
import { NAMES as SERVER_VOD_SETTINGS_UPDATE } from 'shared/redux/server/actions/vod-settings/update';
import { NAMES as SERVER_VOD_SETTINGS_RESET } from 'shared/redux/server/actions/vod-settings/reset';

import { DEFAULT_CURRENCY } from 'shared/constants/currencies';
import DEFAULT_VIDEO_DEAL_INFO from 'shared/constants/default-video-deal-info';
import withReplace from 'shared/redux/helpers/vod-settings-replace';


const defaultVODSettings = {
  currency: DEFAULT_CURRENCY,
  memberOnly: false,
  dealInfo: DEFAULT_VIDEO_DEAL_INFO,
};


function mergeResponseData(state, { payload }) {
  return _.mergeWith({}, defaultVODSettings, state, payload.response, withReplace);
}

export default handleActions({
  [SERVER_VOD_SETTINGS_GET.SUCCESS]: mergeResponseData,
  [SERVER_VOD_SETTINGS_UPDATE.SUCCESS]: mergeResponseData,
  [SERVER_VOD_SETTINGS_RESET.SUCCESS]: () => _.merge({}, defaultVODSettings),
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/vod-settings.js